export class RedirectException extends Error {
  constructor() {
    super('Redirect required');
    this.name = 'RedirectException';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
